module.exports = __webpack_public_path__ + "media/reskin-images/orders-8c292cbc.svg";